import React from 'react';

export interface GraficoIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const GraficoIcon: React.FC<GraficoIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21.687 5.293h-3.292v17.292h3.291zm-6.899 4h-3.292v13.292h3.292zm-6.899 8H4.597v5.292H7.89z"/>
    </svg>
  );
};

export default GraficoIcon;
